import React, { useState } from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputCheckBoxUI from '../../../widgets/form/InputCheckBoxUI'
import './LoanCreateModal.css'

const LoanCreateModalUI = ({ context, successMsg, errorList, setErrorList, loan,
  // modes
  createMode, submitted,
  // event handlers
  onSubmit, onCancelCreate,
  // form fields
  loanName, onLoanNameChange, loanNameError, setLoanNameError, loanNameList,
  loanType, onLoanTypeChange, loanTypeError, setLoanTypeError, loanTypeList,
  appFlavor, onAppFlavorChange, appFlavorError, setAppFlavorError, appFlavorList,
  loanPurpose, onLoanPurposeChange, loanPurposeError, setLoanPurposeError, loanPurposeList, sectorList,
  loanSubType, onLoanSubTypeChange, loanSubTypeError, setLoanSubTypeError, loanSubTypeList,
  loanAmountF, onLoanAmountFChange, loanAmountFError, setLoanAmountFError,
  tenureMonths, onTenureMonthsChange, tenureMonthsError, setTenureMonthsError,
  onLoanTenureMonthsChange, loanTenureMonths, loanTenureMonthsError, setLoanTenureMonthsError,
  capex, onCapexChange,
  interestTenureMonths, onInterestTenureMonthsChange, interestTenureMonthsError, setinterestTenureMonthsError
}) => {
  const [showLoanTenure, setShowLoanTenure] = useState(false);
  const onShowLoanTenure = () => {
    setShowLoanTenure(prevShowLoanTenure => !prevShowLoanTenure);
  };
  return (
    <ModalFormUI
      context={context}
      titleLabel='Create loan'
      buttonLabel='Create loan'
      cancelLabel='Cancel'
      isOpen={createMode}
      onRequestClose={onCancelCreate}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
      <div className='g_flex_h g_flex_top c_ln_crt'>
        <div className='col'>
          <InputTextSF type='text' name='s_name' required={true} maxLength={12}
            label='Loan name' autoFocus={true}
            value={loanName} onChange={onLoanNameChange}
            error={loanNameError} setError={setLoanNameError}
          />
          <InputSelectSF type='select' name='loanType' required={true} label='Loan type'
            value={loanType} optionList={loanTypeList}
            onChange={onLoanTypeChange} error={loanTypeError} setError={setLoanTypeError}
          />
          <InputSelectSF type='select' name='loanSubType' required={true} label='Loan subtype'
            value={loanSubType} optionList={loanSubTypeList}
            onChange={onLoanSubTypeChange} error={loanSubTypeError} setError={setLoanSubTypeError}
          />
          <InputSelectSF type='select' name='loanPurpose' required={true} label='Purpose'
            value={loanPurpose} optionList={sectorList}
            onChange={onLoanPurposeChange} error={loanPurposeError} setError={setLoanPurposeError}
          />
          <InputSelectSF type='select' name='appFlavor' required={true} label='App flavor'
            value={appFlavor} optionList={appFlavorList}
            onChange={onAppFlavorChange} error={appFlavorError} setError={setAppFlavorError}
          />
        </div>

        <div className='g_m_left_100 col'>
          <InputTextSF type='text' name='s_amt' required={true} maxLength={12}
            label='Loan amount (₹)'
            value={loanAmountF} onChange={onLoanAmountFChange}
            error={loanAmountFError} setError={setLoanAmountFError}
          />
          <InputTextSF type='text' name='s_tnr' required={true} maxLength={2}
            label='Amortized/Interest tenure (months)'
            value={tenureMonths} onChange={onTenureMonthsChange}
            error={tenureMonthsError} setError={setTenureMonthsError}
          />
          {(loanType === 'project' || loanType === 'int_then_prj') && (
            <>
              <InputCheckBoxUI
                label='Loan tenure months shorter than amortized months'
                onChange={onShowLoanTenure}
                checked={showLoanTenure}
                name='showLoanTenure'
              />
              {showLoanTenure && (
                <InputTextSF
                  type='text'
                  name='s_tnr'
                  maxLength={3}
                  label='Loan tenure (months)'
                  value={loanTenureMonths}
                  onChange={onLoanTenureMonthsChange}
                  error={loanTenureMonthsError}
                  setError={setLoanTenureMonthsError}
                />
              )}
            </>
          )}
          {
            (loanType === 'int_then_prj') &&
            <InputTextSF type='text' name='s_tnr' required={true} maxLength={2}
              label='Interest tenure months'
              value={interestTenureMonths} onChange={onInterestTenureMonthsChange}
              error={interestTenureMonthsError} setError={setinterestTenureMonthsError}
            />
          }
          <InputCheckBoxUI label='Capital expenditure'
            onChange={onCapexChange} checked={capex}
            name='capex'
          />
        </div>
      </div>
    </ModalFormUI>
  )
}

export default LoanCreateModalUI
